export const CONNECTION_STATUS = {
  PENDING: 0,
  APROVED: 1,
  REFUSED: 2,
};

export const CONNECTION_STATUS_LABELS = {
  [CONNECTION_STATUS.PENDING]: 'Pendente',
  [CONNECTION_STATUS.APROVED]: 'Aprovado',
  [CONNECTION_STATUS.REFUSED]: 'Recusado',
};

export const CONNECTION_STATUS_FILTER = {
  [CONNECTION_STATUS_LABELS[CONNECTION_STATUS.PENDING]]: CONNECTION_STATUS.PENDING,
  [CONNECTION_STATUS_LABELS[CONNECTION_STATUS.APROVED]]: CONNECTION_STATUS.APROVED,
  [CONNECTION_STATUS_LABELS[CONNECTION_STATUS.REFUSED]]: CONNECTION_STATUS.REFUSED,
};
